/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'play-block': {
    width: 100,
    height: 100,
    viewBox: '0 0 100 100',
    data: '<circle pid="0" opacity=".8" cx="50" cy="50" r="50" _fill="#004C97"/><path pid="1" d="M35.585 28.661c0-1.582 1.75-2.537 3.081-1.682l31.298 20.119a2 2 0 010 3.365l-31.298 20.12c-1.33.855-3.08-.101-3.08-1.683V28.66zm2 40.239l31.297-20.12-31.297-20.119V68.9z" _fill="#fff"/>'
  }
})
